import scarinciLogo from "@/assets/scarinci-hollenbeck-logo.webp";
import peterAvatar from "@/assets/peter-moeller-scarinci-hollenbeck.webp";
import {
  Attribution,
  CountUp,
  QuoteCard,
  useInViewRef,
} from "@/components/sections/testimonial/shared";

export function Step4Testimonial() {
  const { ref, inView } = useInViewRef<HTMLElement>();

  return (
    <section ref={ref} className="flex flex-col">
      <div className="flex flex-wrap items-baseline gap-x-4 gap-y-2">
        <h2 className="text-4xl font-bold tracking-tight text-foreground">
          Our site was ready in
        </h2>
        <span className="text-gradient-cycle text-6xl font-bold sm:text-7xl lg:text-8xl tabular-nums">
          <CountUp target={7} start={inView} />
        </span>
        <h2 className="text-4xl font-bold tracking-tight text-foreground">
          days
        </h2>
      </div>

      <QuoteCard>
        I needed something fast. They had my site live before I even told my
        accountant we were{" "}
        <span className="text-gradient-cycle font-bold">redesigning.</span>
      </QuoteCard>


      <Attribution
        avatarSrc={peterAvatar}
        avatarAlt="Peter Moeller"
        name="Peter Moeller"
        role="Marketing Director, Scarinci Hollenbeck"
        logoSrc={scarinciLogo}
        logoAlt="Scarinci Hollenbeck logo"
        logoClassName="h-8 shrink-0"
        nameNoWrap
      />
    </section>
  );
}
